import { render } from "./WordQueryWidget.vue?vue&type=template&id=8cf38040&scoped=true"
import script from "./WordQueryWidget.vue?vue&type=script&lang=js"
export * from "./WordQueryWidget.vue?vue&type=script&lang=js"

import "./WordQueryWidget.vue?vue&type=style&index=0&id=8cf38040&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf38040"]])

export default __exports__